export default function currencySwitcher(){

    const apiUrl = "https://api.exchangerate-api.com/v4/latest/EUR";
    const currencyBtn = document.querySelectorAll(".currency-dropdown__menu .dropdown-item");
    const priceElements = document.querySelectorAll(".price-currency-switcher .price");

    priceElements.forEach(priceElement => {
        const price = priceElement.getAttribute("data-value");

        if (currencyBtn.length) {
            currencyBtn.forEach(function (btn) {
                btn.addEventListener("click", function (e) {
                    const currencySelected = this.getAttribute("data-currency");
                    const symbol = this.getAttribute("data-symbol");
                    e.preventDefault();
                    getResults(currencySelected, symbol, priceElement, price);
                });
            });
        }
    });

    function getResults(currencySelected = "EUR", symbol = "€", priceElement, price) {
        fetch(apiUrl)
            .then((response) => response.json())
            .then((data) => displayResult(data.rates, currencySelected, symbol, priceElement, price))
            .catch((err) => console.log(err));
    }

    function displayResult(rates, currencySelected, symbol, priceElement, price) {
        const rateValue = rates[currencySelected];
        const currentCurrencyPrice = Math.round(price * rateValue);
        const currentPriceFormatter = new Intl.NumberFormat("en-EN", {
            style: "currency",
            currency: currencySelected,
            maximumFractionDigits: 0,
        });
        priceElement.textContent = currentPriceFormatter.format(currentCurrencyPrice);
    }

}